"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Celcius_1 = require("./Celcius");
var Fahrenheit_1 = require("./Fahrenheit");
var Kelvin_1 = require("./Kelvin");
var Reamur_1 = require("./Reamur");
var Newton_1 = require("./Newton");
var Rankine_1 = require("./Rankine");
var Delisle_1 = require("./Delisle");
var Romer_1 = require("./Romer");
var Temperatures;
(function (Temperatures) {
    Temperatures[Temperatures["Celcius"] = 0] = "Celcius";
    Temperatures[Temperatures["Fahrenheit"] = 1] = "Fahrenheit";
    Temperatures[Temperatures["Kelvin"] = 2] = "Kelvin";
    Temperatures[Temperatures["Reamur"] = 3] = "Reamur";
    Temperatures[Temperatures["Newton"] = 4] = "Newton";
    Temperatures[Temperatures["Rankine"] = 5] = "Rankine";
    Temperatures[Temperatures["Delisle"] = 6] = "Delisle";
    Temperatures[Temperatures["Romer"] = 7] = "Romer";
})(Temperatures || (Temperatures = {}));
exports.Temperatures = Temperatures;
var Temperature = /** @class */ (function () {
    function Temperature() {
    }
    Temperature._nothing = function (val) { return val; };
    ;
    Temperature.prototype.formula = function () {
        return [
            [Temperature._nothing, Celcius_1.Celcius.toFahrenheit, Celcius_1.Celcius.toKelvin, Celcius_1.Celcius.toReamur, Celcius_1.Celcius.toNewton, Celcius_1.Celcius.toRankine, Celcius_1.Celcius.toDelisle, Celcius_1.Celcius.toRomer],
            [Fahrenheit_1.Fahrenheit.toCelcius, Temperature._nothing, Fahrenheit_1.Fahrenheit.toKelvin, Fahrenheit_1.Fahrenheit.toReamur, Fahrenheit_1.Fahrenheit.toNewton, Fahrenheit_1.Fahrenheit.toRankine, Fahrenheit_1.Fahrenheit.toDelisle, Fahrenheit_1.Fahrenheit.toRomer],
            [Kelvin_1.Kelvin.toCelcius, Kelvin_1.Kelvin.toFahrenheit, Temperature._nothing, Kelvin_1.Kelvin.toReamur, Kelvin_1.Kelvin.toNewton, Kelvin_1.Kelvin.toRankine, Kelvin_1.Kelvin.toDelisle, Kelvin_1.Kelvin.toRomer],
            [Reamur_1.Reamur.toCelcius, Reamur_1.Reamur.toFahrenheit, Reamur_1.Reamur.toKelvin, Temperature._nothing, Reamur_1.Reamur.toNewton, Reamur_1.Reamur.toRankine, Reamur_1.Reamur.toDelisle, Reamur_1.Reamur.toRomer],
            [Newton_1.Newton.toCelcius, Newton_1.Newton.toFahrenheit, Newton_1.Newton.toKelvin, Newton_1.Newton.toReamur, Temperature._nothing, Newton_1.Newton.toRankine, Newton_1.Newton.toDelisle, Newton_1.Newton.toRomer],
            [Rankine_1.Rankine.toCelcius, Rankine_1.Rankine.toFahrenheit, Rankine_1.Rankine.toKelvin, Rankine_1.Rankine.toReamur, Rankine_1.Rankine.toNewton, Temperature._nothing, Rankine_1.Rankine.toDelisle, Rankine_1.Rankine.toRomer],
            [Delisle_1.Delisle.toCelcius, Delisle_1.Delisle.toFahrenheit, Delisle_1.Delisle.toKelvin, Delisle_1.Delisle.toReamur, Delisle_1.Delisle.toNewton, Delisle_1.Delisle.toRankine, Temperature._nothing, Delisle_1.Delisle.toRomer],
            [Romer_1.Romer.toCelcius, Romer_1.Romer.toFahrenheit, Romer_1.Romer.toKelvin, Romer_1.Romer.toReamur, Romer_1.Romer.toNewton, Romer_1.Romer.toRankine, Romer_1.Romer.toDelisle, Temperature._nothing]
        ];
    };
    Temperature.convert = function (value, from, to) {
        try {
            var x = new Temperature();
            var formulas = x.formula();
            try {
                var formula = formulas[from][to];
                if (!formula)
                    throw 'err';
                return formula(value);
            }
            catch (err) {
                throw 'No formula found! Please check unit supplied';
            }
        }
        catch (err) {
            throw err;
        }
    };
    Temperature.unit = {
        Celcius: Temperatures.Celcius, Fahrenheit: Temperatures.Fahrenheit,
        Kelvin: Temperatures.Kelvin, Reamur: Temperatures.Reamur,
        Newton: Temperatures.Newton, Rankine: Temperatures.Rankine,
        Delisle: Temperatures.Delisle, Romer: Temperatures.Delisle
    };
    Temperature.units = [
        Celcius_1.Celcius.unit,
        Fahrenheit_1.Fahrenheit.unit,
        Kelvin_1.Kelvin.unit,
        Reamur_1.Reamur.unit,
        Newton_1.Newton.unit,
        Rankine_1.Rankine.unit,
        Delisle_1.Delisle.unit,
        Romer_1.Romer.unit
    ];
    return Temperature;
}());
exports.Temperature = Temperature;
